import { c as _c } from "react/compiler-runtime";
import Skeleton from 'react-loading-skeleton';
import { CarouselSkeleton } from '@module/mdrt-org/shared/components/carousel/components/carousel-skeleton';
import styles from './learn-content-carousel-skeleton.module.scss';
export const LearnContentCarouselSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <CarouselSkeleton>{[1, 2, 3, 4, 6, 7, 8, 9, 10].map(_temp)}</CarouselSkeleton>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
function _temp(key) {
  return <div className={styles["card-skeleton"]} key={key}><Skeleton borderRadius={16} /></div>;
}